import useDarkMode from "use-dark-mode";

const Logo = ({ darkModeOverride }: { darkModeOverride?: boolean }) => {
  const darkMode = useDarkMode(false);
  const darkModeValue = darkModeOverride !== undefined ? darkModeOverride : darkMode.value;

  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 148.38 135.31">
      <g id="Layer_2" data-name="Layer 2"><rect x="31.13" y="35.39" width="89.51" height="70.59"
        style={{ fill: darkModeValue ? "#272b31" : "#FFFFFF" }}
      />
      </g>
      <path
        d="M61.83,79.85H101a6.42,6.42,0,0,1,0,12.84H61.83a6.42,6.42,0,0,1,0-12.84M48.91,55.1H114a6.42,6.42,0,1,1,0,12.83h-65a6.42,6.42,0,1,1,0-12.83ZM71,104.61H91.86a6.42,6.42,0,1,1,0,12.83H71a6.42,6.42,0,1,1,0-12.83Zm81.85-32.77L127.19,27.37C123.51,21,114.47,15.78,107.1,15.78H55.76c-7.36,0-16.4,5.22-20.08,11.59L10,71.84C6.33,78.21,6.33,88.65,10,95l25.67,44.46c3.68,6.38,12.72,11.6,20.08,11.6H107.1c7.37,0,16.41-5.22,20.09-11.6L152.86,95C156.54,88.65,156.54,78.21,152.86,71.84Z" transform="translate(-7.25 -15.78)"
        fill={darkModeValue ? "#FFFFFF" : "#272b31"}
      />
    </svg>
  )
}

export default Logo